import { render, staticRenderFns } from "./YesIcon.vue?vue&type=template&id=23583f8d&scoped=true"
import script from "./YesIcon.vue?vue&type=script&lang=ts"
export * from "./YesIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23583f8d",
  null
  
)

export default component.exports